"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfilePictureBubble = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_intl_1 = require("react-intl");
const constants_1 = require("./constants");
const ProfilePictureBubble_module_css_1 = __importDefault(require("./ProfilePictureBubble.module.css"));
const WebPImage_1 = require("../Images/WebPImage");
const UserIcon_1 = require("../../icons/UserIcon");
const getProfilePictureRingStyles = ({ hasFinishedStory, noHighlight, }) => {
    if (noHighlight) {
        return ProfilePictureBubble_module_css_1.default.noHighlightBorder;
    }
    return hasFinishedStory ? ProfilePictureBubble_module_css_1.default.hasFinishedStoryBorder : ProfilePictureBubble_module_css_1.default.noFinishedStoryBorder;
};
const getDisplayPictureStyle = (size, backgroundColor) => {
    backgroundColor = backgroundColor || "var(--page-bg-color)";
    return {
        height: size,
        width: size,
        borderRadius: "50%",
        backgroundColor,
    };
};
/**
 * Profile Picture Bubble
 */
function ProfilePictureBubble({ size, profilePictureUrl, hasStory, hasFinishedStory, noHighlight, onStoryClick, backgroundColor, }) {
    const sizeInPx = constants_1.PROFILE_PICTURE_SIZES_TO_PIXELS[size];
    const intl = (0, react_intl_1.useIntl)();
    const borderStyles = hasStory
        ? getProfilePictureRingStyles({ hasFinishedStory, noHighlight })
        : "";
    const sizeStyles = {
        height: sizeInPx + 6,
        width: sizeInPx + 6,
    };
    const displayPictureStyles = getDisplayPictureStyle(sizeInPx, backgroundColor);
    return ((0, jsx_runtime_1.jsxs)("div", { className: `${ProfilePictureBubble_module_css_1.default.profilePictureWrapper} ${borderStyles}`, style: sizeStyles, onClick: onStoryClick, "data-testid": "profilePicture", children: [profilePictureUrl && ((0, jsx_runtime_1.jsx)("div", { style: displayPictureStyles, children: (0, jsx_runtime_1.jsx)(WebPImage_1.WebPImage, { url: profilePictureUrl, alt: intl.formatMessage({
                        defaultMessage: "Profile Picture",
                        description: "Placeholder text for a Snap user's profile picture",
                    }), borderRadiusAsString: "50%" }) })), !profilePictureUrl && ((0, jsx_runtime_1.jsx)("div", { className: ProfilePictureBubble_module_css_1.default.userIcon, children: (0, jsx_runtime_1.jsx)(UserIcon_1.UserIcon, { size: sizeInPx }) }))] }));
}
exports.ProfilePictureBubble = ProfilePictureBubble;
//# sourceMappingURL=ProfilePictureBubble.js.map